import { OverallValidationResult, validator } from '../../../../util'
import { StrategyStepState } from '../strategy-slice'
import { leverageConstantProportionRules } from './leverage-constant-proportion'
import { leverageVolControlRules } from './leverage-vol-control'
import { protectionContinuousRules, protectionTermRules } from './protection'
import { riskManagedRules } from './risk-managed'

const riskManagedValidator = validator(riskManagedRules)
const leverageVolControlValidator = validator(leverageVolControlRules)
const leverageConstantProportionValidator = validator(leverageConstantProportionRules)
const protectionContinuousValidator = validator(protectionContinuousRules)
const protectionTermValidator = validator(protectionTermRules)

export function validate(strategy: StrategyStepState): OverallValidationResult {
  switch (strategy.selectedStrategy.type) {
    case 'delta1': {
      return {
        isValid: true,
        errors: {}
      }
    }
    case 'riskmanaged': {
      return riskManagedValidator(strategy)
    }
    case 'leverage': {
      if (strategy.selectedStrategy.leverage.type === 'vol-control') {
        return leverageVolControlValidator(strategy)
      }
      if (strategy.selectedStrategy.leverage.type === 'constant-proportion') {
        return leverageConstantProportionValidator(strategy)
      }
      return {
        isValid: false,
        errors: {}
      }
    }
    case 'protection': {
      if (strategy.selectedStrategy.protection.type === 'continuous') {
        return protectionContinuousValidator(strategy)
      }
      if (strategy.selectedStrategy.protection.type === 'term') {
        return protectionTermValidator(strategy)
      }
      return {
        isValid: false,
        errors: {}
      }
    }
  }
}
